import React from 'react';
import DocumentTitle from 'react-document-title';
import { LoadingIndicator } from '../../../shared/components/LoadingIndicator';
import { PageLayout, PageLayoutProps } from './Layout';
import { PageLocation } from './Location';
import { PageAnalytics } from './Analytics';
import { PageThemeProvider } from './ThemeProvider';

const darkThemePaths = ['/artist/:artistId/profile'];

export function Page(props: PageLayoutProps) {
  return (
    <DocumentTitle title={process.env.REACT_APP_TITLE || ''}>
      <React.Suspense fallback={<LoadingIndicator />}>
        <PageAnalytics />
        <PageLocation>
          <PageThemeProvider darkThemePaths={darkThemePaths}>
            <PageLayout {...props} />
          </PageThemeProvider>
        </PageLocation>
      </React.Suspense>
    </DocumentTitle>
  );
}
